import dayjs from "dayjs";

export function formatDate(date = new Date(), format = "DD-MM-YYYY, HH:mm") {
  return dayjs(date).format(format);
}
